/**
 * Hook useSubscription (versão P0.1)
 * Wrapper fino que lê do SubscriptionProvider para evitar múltiplos canais Realtime.
 * Mantém a mesma API pública para os consumidores atuais.
 */

export type {
  Subscription,
  FeatureUsage,
  SubscriptionLimits,
} from '../contexts/SubscriptionContext';

import { useSubscriptionContext } from '../contexts/SubscriptionContext';

export function useSubscription() {
  return useSubscriptionContext();
}
